import { Grid } from '@material-ui/core';
import CustomRadio from 'components/CustomRadio';

const FollowUpActions = ({
    classes,
    viewOnly,
    reportData,
    handleChange,
    forceErrorDisplay,
}) => {
    return (
        <Grid style={{ paddingLeft: 15 }}>
            <Grid container className={classes.subItem}>
                <Grid container>
                    <div>
                        3.1 Any alteration of protocol required?
                    </div>
                    <Grid container className={classes.subItem}>
                        <Grid container alignItems='center'>
                            <CustomRadio
                                isRequired
                                forceErrorDisplay={forceErrorDisplay}
                                onChange={(e) =>handleChange('isAlterationRequired',JSON.parse(e.target.value))}
                                value={reportData?reportData.isAlterationRequired:null}
                                disabled={viewOnly}
                                operators={[
                                    {
                                        key: true,
                                        label: 'Yes (please submit Protocol Amendment Application)',
                                    },
                                    {
                                        key: false,
                                        label: 'No',
                                    },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.subItem}>
                    <div>
                        3.2 Any recommendation from the Data Monitoring Committee?
                    </div>
                    <Grid container className={classes.subItem}>
                        <Grid container alignItems='center'>
                            <CustomRadio
                                isRequired
                                forceErrorDisplay={forceErrorDisplay}
                                onChange={(e) => handleChange('anyRecommendation',JSON.parse(e.target.value))}
                                disabled={viewOnly}
                                value={reportData?reportData.anyRecommendation:null}
                                operators={[
                                    {
                                        key: true,
                                        label: 'Yes (please attach relevant document)',
                                    },
                                    {
                                        key: false,
                                        label: 'No',
                                    },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
export default FollowUpActions;
